import { useState, useEffect } from "react";

function useWindowWidth() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowWidth, setWindowWidth] = useState({ width: undefined });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowWidth({
        width: window.innerWidth,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  if (Number(windowWidth.width) < 640) {
    return "sm";
  } else if (Number(windowWidth.width) < 768) {
    return "md ";
  } else if (Number(windowWidth.width) < 1024) {
    return "lg";
  } else if (Number(windowWidth.width) < 1280) {
    return "xl";
  } else if (Number(windowWidth.width) < 1280) {
    return "xxl";
  } else {
    return "gg";
  }
}

export default useWindowWidth;
